module.exports = __webpack_public_path__ + "img/iosStep-5.0e978419.webp";